import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { SubSink } from 'subsink';
import { SessionService } from '../../services/auth/session.service';

@Component({
  selector: 'tcat-app-container',
  templateUrl: './app-container.component.html',
  styleUrls: ['./app-container.component.scss']
})
export class AppContainerComponent implements OnInit, OnDestroy {

  isLoggedIn = false;

  subSink = new SubSink();

  constructor(
    private sessionService: SessionService
  ) {

  }

  ngOnInit() {
    this.subSink.sink = this.sessionService.session()
      .subscribe(session => {
        this.isLoggedIn = session != null && session.isInitialized;
      });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
